if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.mediaItems = [];
        this.currentMediaIndex = 0;
        this.previousButton = this.querySelector('[data-media-modal-previous]');
        this.nextButton = this.querySelector('[data-media-modal-next]');
        this.content = this.querySelector('.product-media-modal__content');
        this.closeButton = this.querySelector('[id^="ModalClose-"]');
        this.boundUpdateCloseButtonPosition = this.updateCloseButtonPosition.bind(this);
        this.closeButtonPositionTimers = [];

        this.previousButton?.addEventListener('click', this.showPreviousMedia.bind(this));
        this.nextButton?.addEventListener('click', this.showNextMedia.bind(this));
        [this.previousButton, this.nextButton, this.content].forEach((element) => {
          element?.addEventListener('pointerup', (event) => event.stopPropagation());
        });
        window.addEventListener('resize', this.boundUpdateCloseButtonPosition);
        this.content?.addEventListener('scroll', this.boundUpdateCloseButtonPosition);

        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;
          if (event.code.toUpperCase() === 'ARROWLEFT') {
            event.preventDefault();
            this.showPreviousMedia();
          }
          if (event.code.toUpperCase() === 'ARROWRIGHT') {
            event.preventDefault();
            this.showNextMedia();
          }
        });
      }

      hide() {
        super.hide();
        this.closeButtonPositionTimers.forEach((timer) => window.clearTimeout(timer));
        this.closeButtonPositionTimers = [];
        this.closeButton?.removeAttribute('style');
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia(this.openedBy?.getAttribute('data-media-id'));
      }

      getMediaItems() {
        return Array.from(this.querySelectorAll('.product-media-modal__content [data-media-id]'));
      }

      showPreviousMedia() {
        this.showMediaAtIndex(this.currentMediaIndex - 1);
      }

      showNextMedia() {
        this.showMediaAtIndex(this.currentMediaIndex + 1);
      }

      showMediaAtIndex(index) {
        this.mediaItems = this.getMediaItems();
        if (!this.mediaItems.length) return;

        const itemCount = this.mediaItems.length;
        const nextIndex = (index + itemCount) % itemCount;
        const activeMedia = this.mediaItems[nextIndex];

        window.pauseAllMedia();
        this.setActiveMedia(activeMedia);
      }

      showActiveMedia(mediaId) {
        this.mediaItems = this.getMediaItems();
        if (!this.mediaItems.length) return;

        const activeMedia =
          this.mediaItems.find((element) => element.getAttribute('data-media-id') === mediaId) || this.mediaItems[0];

        this.setActiveMedia(activeMedia);
      }

      setActiveMedia(activeMedia) {
        this.mediaItems.forEach((element) => {
          element.classList.toggle('active', element === activeMedia);
        });

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        this.currentMediaIndex = this.mediaItems.indexOf(activeMedia);
        this.updateNavigation();
        activeMedia.scrollIntoView({ block: 'nearest', inline: 'center' });

        const container = this.content || this.querySelector('[role="document"]');
        const activeMediaWidth = activeMedia.clientWidth || activeMedia.width || container.clientWidth;
        container.scrollLeft = Math.max((activeMediaWidth - container.clientWidth) / 2, 0);
        this.scheduleCloseButtonPositionUpdate(activeMedia);

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      updateNavigation() {
        const shouldShowNavigation = this.mediaItems.length > 1;
        [this.previousButton, this.nextButton].forEach((button) => {
          if (!button) return;
          button.toggleAttribute('hidden', !shouldShowNavigation);
        });
      }

      scheduleCloseButtonPositionUpdate(activeMedia) {
        this.closeButtonPositionTimers.forEach((timer) => window.clearTimeout(timer));
        this.closeButtonPositionTimers = [];

        const update = () => this.updateCloseButtonPosition();
        window.requestAnimationFrame(() => {
          update();
          window.requestAnimationFrame(update);
        });

        [120, 300, 600].forEach((delay) => {
          this.closeButtonPositionTimers.push(window.setTimeout(update, delay));
        });

        const image = activeMedia?.tagName === 'IMG' ? activeMedia : activeMedia?.querySelector?.('img');
        if (!image) return;

        if (!image.complete) {
          image.addEventListener('load', update, { once: true });
        }
        image.decode?.().then(update).catch(() => {});
      }

      updateCloseButtonPosition() {
        if (!this.hasAttribute('open') || !this.closeButton) return;

        const activeMedia =
          this.mediaItems[this.currentMediaIndex] || this.querySelector('.product-media-modal__content .active');
        if (!activeMedia) return;

        const activeMediaRect = activeMedia.getBoundingClientRect();
        const buttonSize = this.closeButton.offsetWidth || 40;
        const inset = 12;
        const top = Math.max(activeMediaRect.top + inset, inset);
        const left = Math.min(
          Math.max(activeMediaRect.right - buttonSize - inset, inset),
          window.innerWidth - buttonSize - inset
        );

        this.closeButton.style.top = `${top}px`;
        this.closeButton.style.left = `${left}px`;
        this.closeButton.style.right = 'auto';
      }
    }
  );
}
